export function getShellVersion(o: unknown): string {
  const psVersion = o['PSVersion'] || undefined;

  if (psVersion) {
    return `${psVersion['Major']}.${psVersion['Minor']}.${psVersion['Build']}.${psVersion['Revision']}`;
  }

  return undefined;
}
